import { render, staticRenderFns } from "./GlassForm.vue?vue&type=template&id=2a5b0e4c"
import script from "./GlassForm.vue?vue&type=script&lang=js"
export * from "./GlassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports